/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceTypeResponse,
    DeviceTypeResponseFromJSON,
    DeviceTypeResponseFromJSONTyped,
    DeviceTypeResponseToJSON,
} from './DeviceTypeResponse';

/**
 * 
 * @export
 * @interface DeviceTypesResponse
 */
export interface DeviceTypesResponse {
    /**
     * 
     * @type {Array<DeviceTypeResponse>}
     * @memberof DeviceTypesResponse
     */
    elements: Array<DeviceTypeResponse>;
}

export function DeviceTypesResponseFromJSON(json: any): DeviceTypesResponse {
    return DeviceTypesResponseFromJSONTyped(json, false);
}

export function DeviceTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(DeviceTypeResponseFromJSON)),
    };
}

export function DeviceTypesResponseToJSON(value?: DeviceTypesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(DeviceTypeResponseToJSON)),
    };
}

